<script>
  import { onMount, getContext, tick } from 'svelte';
  import { slide } from "svelte/transition"
  import { createPostRequest } from '../../../src/create_request'
  import { scrollTo, scrollRef, scrollTop } from 'svelte-scrolling'
  import { cart, settings } from '../../../src/data_storage.js'
  settings.useLocalStorage()
  cart.useLocalStorage()

  import InputField from '../../inputs/input_field.svelte'
  import { _, locale, locales } from 'svelte-i18n'
  import { cryptos, filteredCryptos, focus, formatCurrency } from '../../../src/utils'
  import CryptoConvert from 'crypto-convert'

  export let shop
  export let order
  export let done_handler
  const { imageUrl } = getContext('app')

  let crypto = null
  let errors = null
  let showCryptoPayments = false
  let availableCryptos
  let cryptoAddresses = shop.settings['crypto_addresses']
  availableCryptos = cryptos.filter((item) => cryptoAddresses[item.id]!==null && cryptoAddresses[item.id]!=="")

  let email
  let name
  let transactionId

  function handleSubmit() {
    fetch(createPostRequest('/cart/checkout_submit.json',
                        'POST',
                        JSON.stringify({ slug: shop.slug, order_id: order.id })))
      .then(response => response.json())
      .then(data => {
        console.log('checkout_submit:' + shop.slug)
        console.log(data)
        if (data.errors) {
          // alert(data.errors.email)
          errors = data.errors
        } else if (data.id) {
          if (done_handler) {
            done_handler(data)
          }
        } else {
          errors = ["Something went wrong, try again later."]
        }
      })
      .catch(err => {
        alert('error ' + err)
      })
  }

  onMount(async () => {
    console.log("cryptoPay onMount " + shop.slug)
    console.log('availableCryptos: ')
    console.log(availableCryptos)
  })

  function choose(cryptoLogo) {
    console.log('choose crypto:' + cryptoLogo.id)
    crypto = cryptoLogo
    crypto.address = cryptoAddresses[cryptoLogo.id]
    if (crypto.address) {
      showCryptoPayments = true
      console.log('chosen address:' + crypto.address)
    }
  }

  function crypto_confirm(){
    let data = {
      confirmation: {
        name: name,
        email: email,
        transaction: transactionId
      },
      crypto: crypto.id,
      crypto_address: crypto.address
    }
    if (done_handler) {
      done_handler(data)
    }
  }

  let paymentMethod = 0
</script>

{#if showCryptoPayments}
  <div class="flex flex-col justify-center items-center">
    <div class="text-lg">You are paying with:</div>
    <div class="shadow border dark:border-black rounded p-2 px-4 w-60 h-40 flex flex-col justify-center items-center">
      <img src={imageUrl('all//crypto/' + (crypto.img || 'logo.png'))} alt={crypto.img || 'logo'}>
      <div>{crypto.title}</div>
    </div>
  </div>

  <div class="mt-3 flex flex-col items-center gap-2">
    <div class="text-lg">Select method:</div>

    <div class="w-60 text-white rounded bg-blue-600 dark:bg-red-600 crypto-manual-button p-4 shadow flex flex-col" on:click={() => paymentMethod=1} use:scrollTo={'paymethod'}>
      <div id="manual-entry" class="text-sm">Manual entry</div>
      <div class="text-xs">(Exchange & Webwallet)</div>
    </div>
    <div class="w-60 text-white rounded bg-blue-600 dark:bg-red-600 crypto-link-button p-4 shadow flex flex-col" on:click={() => paymentMethod=2} use:scrollTo={'paymethod'}>
      <div id="one-click-uri" class="text-sm">1-Click URI</div>
      <div class="text-xs">(Compatible Wallet)</div>
    </div>
    <div class="w-60 text-white rounded bg-blue-600 dark:bg-red-600 crypto-qr-button p-4 shadow" on:click={() => paymentMethod=3} use:scrollTo={'paymethod'}>
      <div id="qr-code" class="text-sm">QR Code</div>
      <div class="text-xs">(Mobile Wallet)</div>
    </div>
  </div>
  <div class="scroll-ref" use:scrollRef={'paymethod'}></div>
  {#if paymentMethod === 1}
    <div class="crypto-manual mt-3 rounded border m-1 dark:border-black" transition:slide>
      <div class="flex flex-col bg-gray-100 dark:bg-black p-2">
        <div class="font-bold text-gray-600">Step #1:</div>
        <div class="text-sm">Copy and paste the wallet address and price into your wallet, validate the details below before sending.</div>
      </div>
      <div class="flex flex-col p-2">
        <div class="font-bold">{crypto.title} address:</div>
        <div id="crypto-address" class="p-4 text-gray-600 dark:text-red-600 break-words">{crypto.address}</div>
      </div>
      <div class="flex flex-col p-2">
        <div class="font-bold">{crypto.title} price:</div>
        <div id="crypto-price" class="p-4 text-gray-600 dark:text-red-600">price!</div>
      </div>
    </div>
  {/if}
  {#if paymentMethod === 2}
    <div class="crypto-link mt-3 rounded border m-1 dark:border-black" transition:slide>
      <div class="flex flex-col bg-gray-100 dark:bg-black p-2">
        <div class="font-bold text-gray-600">Step #1:</div>
        <div class="text-sm">Copy and paste the wallet address and price into your wallet, validate the details below before sending.</div>
      </div>
      <div class="flex flex-col p-2">
        <div class="text-lg">{$_('Click here to send')} {crypto.title}</div>
        <div class="font-bold">{crypto.title} address:</div>
        <div id="crypto-address" class="p-4 text-gray-600 dark:text-red-600 break-words">{crypto.address}</div>
      </div>
      <div class="flex flex-col p-2">
        <div class="font-bold">{crypto.title} price:</div>
        <div id="crypto-price" class="p-4 text-gray-600 dark:text-red-600">price!</div>
      </div>
    </div>
  {/if}
  {#if paymentMethod === 3}
    <div class="crypto-qr mt-3 rounded border m-1 dark:border-black" transition:slide>
      <div class="flex flex-col bg-gray-100 dark:bg-black p-2">
        <div class="font-bold text-gray-600 dark:bg-black">Step #1:</div>
        <div class="text-sm">Copy and paste the wallet address and price into your wallet, validate the details below before sending.</div>
      </div>
      <div class="flex flex-col p-2">
        QR Code
        <div class="font-bold">{crypto.title} address:</div>
        <div id="crypto-address" class="p-4 text-gray-600 dark:text-red-600 break-words">{crypto.address}</div>
      </div>
      <div class="flex flex-col p-2">
        <div class="font-bold">{crypto.title} price:</div>
        <div id="crypto-price" class="p-4 text-gray-600 dark:text-red-600">price!</div>
      </div>
    </div>
  {/if}
  {#if paymentMethod !== 0}
    <div class="crypto-manual mt-3 rounded border m-1 dark:border-black" transition:slide>
      <div class="flex flex-col bg-gray-100 dark:bg-black p-2">
        <div class="font-bold text-gray-600">Step #2:</div>
        <div class="text-sm">After the payment has been sent enter the transaction ID, your name and email, then press "confirm".</div>
      </div>
      <form id="crypto-confirm-form" on:submit|preventDefault={crypto_confirm}>
        <div class="mt-6 flex flex-col gap-4 p-2">
          <div>
            <InputField required class="border-2 dark:border-black dark:bg-black" name="tr" type="text" title="{$_('transaction_id')}" bind:value={transactionId}/>
          </div>
          <div>
            <InputField required class="border-2 dark:border-black dark:bg-black" name="email" type="email" title="{$_('email')}" bind:value={email}/>
          </div>
          <div>
            <InputField class="border-2 dark:border-black dark:bg-black" name="name" type="text" title="{$_('name')}" bind:value={name}/>
          </div>
          {#if errors}
            <div class="mt-3 bg-red-100 flex flex-col items-center justify-center">
              <div>{#if (errors['base'])}{errors['base']}{/if}</div>
            </div>
          {/if}
          <div class="flex justify-center items-center">
            <button class="btn m-3" type="submit">{$_('confirm')}</button>
          </div>
        </div>
      </form>
    </div>
  {/if}
{:else}
  <div class="text-lg">{$_('Choose crypto:')}</div>
  <div class="mt-3 crypto-list flex flex-col gap-2" transition:slide>
    {#each availableCryptos as cryptoLogo}
      <div class="flex flex-col justify-center items-center">
        <button class="shadow border dark:border-black rounded p-2 px-4 w-60 h-40 flex flex-col justify-center items-center" on:click|preventDefault={() => choose(cryptoLogo)}>
          <img src={imageUrl('all//crypto/' + (cryptoLogo.img || 'logo.png'))} alt={cryptoLogo.img || 'logo'}>
          <div>{cryptoLogo.title}</div>
        </button>
      </div>
    {/each}
  </div>
{/if}